module.exports = __webpack_public_path__ + "static/11-gator-c1eca26d9477fa9c91a736a98564b14d.jpg";